export default __webpack_public_path__ + "img/cd6b1752434a82fcaaf697cd2f101752.png";